export default __webpack_public_path__ + "c72b80bf2cb1bc6f04fa801d91854791.svg";